import { createContext } from "react";
import type { useSortable } from "@dnd-kit/sortable";

export interface BlockSortableValue {
  listeners: ReturnType<typeof useSortable>["listeners"];
  isDragging: boolean;
}

export const BlockSortableContext = createContext<BlockSortableValue | undefined>(undefined);
